import { KnmPublishStatusesEnum } from 'APIPackage/KnmModule/enums/KnmPublishStatusesEnum';
import { checkValueInEnum } from 'CorePackage/MainModule/common/checkValueInEnum';
import { publishedStatusesCodesNamesMap } from 'NewsPackage/MainModule/constants/publishedStatuses';

import { RenderFunc } from '../types/RenderFunc';

export const renderPublishedStatus: RenderFunc = item => {
  const { newValue, oldValue } = item;

  return {
    renderedOldValue: checkValueInEnum<KnmPublishStatusesEnum>(oldValue, Object(KnmPublishStatusesEnum))
      ? publishedStatusesCodesNamesMap[oldValue]
      : '',
    renderedNewValue: checkValueInEnum<KnmPublishStatusesEnum>(newValue, Object(KnmPublishStatusesEnum))
      ? publishedStatusesCodesNamesMap[newValue]
      : '',
  };
};
